import { BaseModel } from './BaseModel';
import LearningUnit from './LearningUnit';

export class LearningUnitOption extends BaseModel {
  static get entity() {
    return 'learning_unit_options';
  }

  static get fk() {
    return 'learning_unit_option_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      option_name: this.attr(null),
      option_type: this.attr(null),
      mode: this.attr(null),
      price: this.attr(null),
      discount_price: this.attr(null),
      quota: this.attr(null)
    };
  }

  get isQuota() {
    const { option_type } = this;

    return option_type == 'QUOTA';
  }

  get isEntry() {
    const { option_type } = this;

    return option_type == 'ENTRY';
  }

  static apiConfig = {
    actions: {
      fetch(params = {}) {
        return this.get('/learning-unit-options', {
          params
        });
      },
      fetchOne(id, params = {}) {
        return this.get(`/learning-unit-options/${id}`, {
          params
        });
      }
    }
  };
}

export default LearningUnitOption;
